module.exports = __webpack_public_path__ + "static/img/Kmoney.eaad3d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/portal/Kmoney.png
// module id = 1178
// module chunks = 18